var map = {
	"./anchor-blue.svg": 2083,
	"./arr-down.svg": 2084,
	"./arr-up.svg": 2085,
	"./arrow-down-blue.svg": 2086,
	"./arrow-down-circle.svg": 2087,
	"./arrow-down.svg": 2088,
	"./arrow-left.svg": 2089,
	"./arrow-right.svg": 2090,
	"./arrow-up-circle.svg": 2091,
	"./arrow-up.svg": 2092,
	"./article.svg": 2093,
	"./basket-light.svg": 2094,
	"./basket.svg": 2095,
	"./btn-arrow-dark.svg": 2096,
	"./btn-arrow-down-blue.svg": 2097,
	"./btn-arrow-down.svg": 2098,
	"./btn-arrow.svg": 2099,
	"./btn-info.svg": 2100,
	"./btn-play.svg": 2101,
	"./calendar.svg": 2102,
	"./chevron-down.svg": 2103,
	"./chevron-left.svg": 2104,
	"./chevron-right.svg": 2105,
	"./chevron-up.svg": 2106,
	"./clock.svg": 2107,
	"./cross.svg": 2108,
	"./curve-shape-narrow-swoosh.svg": 2109,
	"./curve-shape-right.svg": 2110,
	"./curve-shape-short.svg": 2111,
	"./curve-shape.svg": 2112,
	"./download.svg": 2113,
	"./facebook.svg": 2114,
	"./gallery.svg": 2115,
	"./i.svg": 2116,
	"./instagram.svg": 2117,
	"./linkedin.svg": 2118,
	"./live-header-logo.svg": 2119,
	"./logo-open.svg": 2120,
	"./menu-close.svg": 2121,
	"./menu-light.svg": 2122,
	"./minus.svg": 2123,
	"./mute.svg": 2124,
	"./pause.svg": 2125,
	"./play.svg": 2126,
	"./plus.svg": 2127,
	"./profile-light.svg": 2128,
	"./radioff.svg": 2129,
	"./radion.svg": 2130,
	"./read.svg": 2131,
	"./restart.svg": 2132,
	"./scores.svg": 2133,
	"./search.svg": 2134,
	"./shop.svg": 2135,
	"./sorting.svg": 2136,
	"./star.svg": 2137,
	"./symbol.svg": 2138,
	"./text.svg": 2139,
	"./tick.svg": 2140,
	"./ticket.svg": 2141,
	"./tiktok.svg": 2142,
	"./track.svg": 2143,
	"./triangle.svg": 2144,
	"./twitter.svg": 2145,
	"./unmute.svg": 2146,
	"./video.svg": 2147,
	"./watch.svg": 2148,
	"./weather--1.svg": 2149,
	"./weather-0.svg": 2150,
	"./weather-1.svg": 2151,
	"./weather-10.svg": 2152,
	"./weather-11.svg": 2153,
	"./weather-12.svg": 2154,
	"./weather-13.svg": 2155,
	"./weather-14.svg": 2156,
	"./weather-15.svg": 2157,
	"./weather-16.svg": 2158,
	"./weather-17.svg": 2159,
	"./weather-18.svg": 2160,
	"./weather-19.svg": 2161,
	"./weather-2.svg": 2162,
	"./weather-20.svg": 2163,
	"./weather-21.svg": 2164,
	"./weather-22.svg": 2165,
	"./weather-23.svg": 2166,
	"./weather-24.svg": 2167,
	"./weather-25.svg": 2168,
	"./weather-26.svg": 2169,
	"./weather-27.svg": 2170,
	"./weather-28.svg": 2171,
	"./weather-29.svg": 2172,
	"./weather-3.svg": 2173,
	"./weather-30.svg": 2174,
	"./weather-4.svg": 2175,
	"./weather-5.svg": 2176,
	"./weather-6.svg": 2177,
	"./weather-7.svg": 2178,
	"./weather-8.svg": 2179,
	"./weather-9.svg": 2180,
	"./weather-NA.svg": 2181,
	"./weather-rain.svg": 2182,
	"./weather-wind.svg": 2183,
	"./youtube.svg": 2184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;